module.exports = __webpack_public_path__ + "img/it-flag.d33f85f0.png";